import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";
import { IMAGES } from "@/lib/siteData";

export default function CTABand() {
  return (
    <section data-testid="cta-band" className="relative bg-gold overflow-hidden">
      <img
        src={IMAGES.cta}
        alt=""
        aria-hidden="true"
        className="absolute right-0 top-0 h-full w-1/2 object-cover opacity-15 mix-blend-multiply"
      />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 py-20 lg:py-28">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-xs uppercase tracking-[0.3em] text-ink/70 mb-5"
        >
          Ready to get started?
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.05 }}
          className="font-heading font-bold tracking-tight text-ink text-4xl sm:text-6xl lg:text-7xl leading-[1] max-w-3xl"
        >
          Let's build something great.
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-10"
        >
          <a
            href="#contact"
            data-testid="cta-band-button"
            className="group inline-flex items-center gap-2 bg-ink text-white font-semibold px-8 py-4 hover:bg-black transition-colors duration-200"
          >
            Request a Free Estimate
            <ArrowRight size={18} weight="bold" className="transition-transform duration-200 group-hover:translate-x-1" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
